/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_UpdateProspectRequest = {
    availability_checked?: boolean;
    availability_checked_at?: string;
    child_date_of_birth?: string;
    child_dob_is_estimated?: boolean;
    child_first_name?: string;
    child_last_name?: string;
    child_notes?: string;
    desired_care_days_per_week?: number;
    desired_care_weekdays?: Array<number>;
    desired_childcare_ids: Array<string>;
    desired_start_date?: string;
    first_contact_channel?: prospects_UpdateProspectRequest.first_contact_channel;
    /**
     * NextFollowupDate is date-only and set by a person. Omitting it CLEARS the
     * column, as omitting any other nullable prospect field does on this endpoint.
     * CreateProspectRequest deliberately has no such member: the quick-capture mask
     * does not set a follow-up date.
     */
    next_followup_date?: string;
    parent1_city?: string;
    parent1_email?: string;
    parent1_first_name: string;
    parent1_house_number?: string;
    parent1_last_name: string;
    parent1_phone?: string;
    parent1_street?: string;
    parent1_zip?: string;
    parent2_email?: string;
    parent2_first_name?: string;
    parent2_last_name?: string;
    parent2_phone?: string;
    remarks?: string;
    subsidized?: prospects_UpdateProspectRequest.subsidized;
    urgency?: prospects_UpdateProspectRequest.urgency;
    version: number;
};
export namespace prospects_UpdateProspectRequest {
    export enum first_contact_channel {
        WEB = 'web',
        PHONE = 'phone',
        EMAIL = 'email',
        WHATSAPP = 'whatsapp',
        IN_PERSON = 'in_person',
    }
    export enum subsidized {
        YES = 'yes',
        NO = 'no',
        UNKNOWN = 'unknown',
    }
    export enum urgency {
        LOW = 'low',
        MEDIUM = 'medium',
        HIGH = 'high',
    }
}

